import { TAGLink } from '@aspendental/shared-components-web';
import { Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

interface TermsAndConditionsProps {
	baseUrl: string;
}

const TermsAndConditions = ({ baseUrl }: TermsAndConditionsProps) => {
	const { t } = useTranslation('index');
	return (
		<Typography variant="bodySmallBook" color="text.secondary" textAlign="center" mb={2.5}>
			{t('consentFromClick')}{' '}
			<TAGLink
				href={`${baseUrl}/legal/terms/`}
				linkSx={{ textDecoration: 'underline', textDecorationColor: '#036896' }}
				openInNewTab
			>
				<Typography variant="bodySmallBook" color="text.interactive">
					{t('termsAndConditions')}
				</Typography>
			</TAGLink>{' '}
			{t('and')}{' '}
			<TAGLink
				href={`${baseUrl}/legal/privacy-policy/`}
				linkSx={{ textDecoration: 'underline', textDecorationColor: '#036896' }}
				openInNewTab
			>
				<Typography variant="bodySmallBook" color="text.interactive">
					{t('privacyPolicy')}
				</Typography>
			</TAGLink>
			.
		</Typography>
	);
};

export default TermsAndConditions;
